import { Box, Typography } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import { ComplianceValidatedEvent, DetectionEvent, TopicMentionEvent } from '../../../../../../../../../../../../../generated/core-api/graphql-react-query';

interface ValidatedEventItemProps {
  sessionEvent: ComplianceValidatedEvent;
}

export default function ValidatedEventItem(props: ValidatedEventItemProps) {
  const { sessionEvent } = props;
  const { t } = useTranslation('session-event');

  const causes = sessionEvent.causes.filter((cause) => cause.event.__typename === 'TopicMentionEvent');
  const result = causes.map((cause) => {
    const event = cause.event as TopicMentionEvent;
    const detectionEvent = event.causes[0].event as DetectionEvent;
    return {
      command: detectionEvent.trigger?.text,
      verbatim: detectionEvent.ASRText,
    };
  });

  const commands = result.map((item) => item.command);
  const verbatim = result.map((item) => item.verbatim);

  if (!causes.length) {
    return null;
  }
  return (
    <Box>
      <Typography variant="body1">
        <Trans
          t={t}
          i18nKey="compliance-required.validated"
          components={{ 1: <strong /> }}
          values={{
            command: commands.join(', '),
          }}
        />
      </Typography>
      <Typography variant="body2">
        {verbatim.join(', ')}
      </Typography>
    </Box>
  );
}
